import React from "react";
import PropTypes from "prop-types";
import isEmail from "validator/lib/isEmail";
import isEmpty from "validator/lib/isEmpty";
import InlineError from "../../widgets/InlineError";

class LoginForm extends React.Component {
    state = {
        data: {
            email: "",
            password: ""
        },
        loading: false,
        errors: {}
    };

    onChange = e =>
        this.setState({
            data: { ...this.state.data, [e.target.name]: e.target.value }
        });

    onSubmit = event => {
        event.preventDefault();
        const errors = this.validate(this.state.data);
        this.setState({ errors });
        // check if there are any errors
        if (Object.keys(errors).length === 0) {
            this.props.submit(this.state.data).catch(err => {
                this.setState({ errors: err.response });
            });
        }
    };
    validate = data => {
        const errors = {};
        if (isEmpty(data.email)) {
            errors.email = "email is a required field";
        } else if (!isEmail(data.email)) {
            errors.email = "a valid email is required";
        }
        if (isEmpty(data.password)) {
            errors.password = "password is a required field";
        }
        return errors;
    };

    render() {
        const { data, errors } = this.state;
        return (
            <div className="col-12">

                <form onSubmit={this.onSubmit}>
                    <div className="col-12">
                        <div className="form-group">
                            <label htmlFor="email" className="field-label">Email address</label>
                            {errors.email && <InlineError text={errors.email} />}
                            <input
                                name="email"
                                type="text"
                                id="email"
                                placeholder="you@email.com"
                                aria-describedby="emailHelp"
                                className="form-control"
                                value={data.email}
                                onChange={this.onChange}
                            />
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="form-group">
                            <label htmlFor="password" className="field-label">Password</label>
                            {errors.password && <InlineError text={errors.password} />}
                            <input
                                name="password"
                                type="password"
                                id="password"
                                placeholder="password"
                                value={data.password}
                                onChange={this.onChange}
                                className="form-control "
                            />
                        </div>
                    </div>
                    {errors.data && <div className="col-12"><InlineError text={errors.data.message} /></div>}
                    <div className="col-12 text-right">
                        <button type="submit" className="btn btn-lg btn-primary w-100">
                            LOGIN
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

LoginForm.propTypes = {
    submit: PropTypes.func.isRequired
};
export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/forms/auth/AuthPage.js